import { defineNuxtPlugin, useRuntimeConfig } from '#app';
import { consola } from 'consola';
declare global {
  interface $logger {
    any;
  }
  interface Window {
    $logger: any;
  }
}
window.$logger = consola;
globalThis.$logger = consola;

export default defineNuxtPlugin((nuxtApp) => {
  const runtimeConfig = useRuntimeConfig();
  consola.level = parseInt(runtimeConfig.public.logsLevel);
  return {
    provide: {
      logger: consola,
    },
  };
});
